import React, { forwardRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicePickerStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISliderWrapperProps {
	children: React.ReactElement;
}

const SliderWrapper = ({ children }: ISliderWrapperProps, ref: React.Ref<HTMLDivElement>) => {
	const classes = useStyles();

	return (
		<div className={classes.sliderWrapper} ref={ref}>
			{children}
		</div>
	);
};

export default forwardRef(SliderWrapper);
